import React, { MutableRefObject } from 'react';
import ReactDOM from 'react-dom';
import IRefProps from './RefProps';

type RefType = Element | Text | HTMLElement | null;

class Ref<T extends Element | Text | HTMLElement | null> extends React.Component<IRefProps<T>> {
  private ref: T | null = null;

  public componentDidMount() {
    // FIXME: findDOMNode will be deprecated at some point
    // eslint-disable-next-line react/no-find-dom-node
    this.ref = ReactDOM.findDOMNode(this) as T;
    this.setRef(this.props.childRef, this.ref);
  }

  public componentDidUpdate(prevProps: IRefProps<T>) {
    // FIXME: findDOMNode will be deprecated at some point
    // eslint-disable-next-line react/no-find-dom-node
    const ref = ReactDOM.findDOMNode(this) as T;

    if (prevProps.childRef !== this.props.childRef || this.ref !== ref) {
      if (prevProps.childRef !== this.props.childRef) {
        this.setRef(prevProps.childRef, null);
      }
      this.ref = ref;
      this.setRef(this.props.childRef, this.ref);
    }
  }

  public componentWillUnmount() {
    this.ref = null;
    this.setRef(this.props.childRef, null);
  }

  public render() {
    return this.props.children;
  }

  private setRef(ref: ((value: T) => void) | React.MutableRefObject<T>, value: T | null) {
    if (typeof ref === 'function') {
      ref(value as T);
    } else if (ref) {
      (ref as MutableRefObject<RefType>).current = value;
    }
  }
}

export default Ref;
